{
  "heroTitle": "Dostlarını dəvət et",
  "heroSub": "Hər uğurlu dəvətə {{bonus}} bonus balans yazılır. Dəvət etdiyiniz dost depozit edəndə məbləğin {{percent}}%-i {{days}} gün sonra sizin real balansınıza keçir — istədiyiniz vaxt çıxarış edə bilərsiniz.",
  "yourLink": "Sənin dəvət linkin",
  "linkHint": "Bu Telegram bot linkidir. Dostunuz linkə keçib botu açanda avtomatik sizin dəvətinizlə qoşulur.",
  "copy": "Kopyala",
  "copied": "Kopyalandı",
  "share": "Paylaş",
  "more": "Daha çox",
  "shareText": "VBB PLAY botuna qoşul! Hər dəvətə {{bonus}} bonus balans, dostunun depozitindən isə {{percent}}% qazanc sənin olur.",
  "infoTitle": "Məlumat",
  "infoSignup": "Hər dəvət etdiyiniz dosta görə {{bonus}} dərhal bonus balansınıza yazılır. Bu məbləğ yalnız bonus oyunlarında istifadə olunur; real balansa qarışdırılmır və birbaşa çıxarış edilmir.",
  "infoBonusGames": "Bonus oyunları: Menyu və ya Bonuslar bölməsindən «Bonus oyunları»na daxil olun. Oyun açarkən bonus balans ilə oynamağı seçin. Uduşlar əvvəlcə bonus balansında qalır; dövriyyə (wager) şərtləri tamamlandıqdan sonra sistem qaydalara uyğun çevirmə aparır. Real pulla açılan adi kazino sessiyaları bu bonusdan istifadə etmir.",
  "infoDeposit": "Dəvət etdiyiniz dost təsdiqlənmiş depozit edəndə depozit məbləğinin {{percent}}%-i sizin üçün komissiya kimi qeydə alınır. Məsələn, dost {{exampleDeposit}} depozit etsə, sizə {{exampleCommission}} düşür.",
  "infoHold": "Depozit komissiyası {{days}} gün gözləmə müddətindən sonra avtomatik real balansınıza keçir. Bu müddət ərzində məbləğ «gözləmədə» görünür; vaxt bitəndə çıxarışa yararlı real balans olur.",
  "infoWithdraw": "Real balansa keçən komissiyanı istədiyiniz vaxt Kassadan çıxarış edə bilərsiniz (platformanın çıxarış qaydalarına uyğun).",
  "infoUnique": "Hər istifadəçinin öz unikal dəvət linki var. Öz linkinizlə özünüzü dəvət etmək mümkün deyil.",
  "invitedLabel": "Dəvət etdiklərin",
  "friendsUnit": "dost",
  "earningsLabel": "Dəvətdən qazancın",
  "earningsSplit": "bonus {{bonus}} · real {{real}}",
  "earningsPending": "gözləmədə {{amount}} ({{days}} gün)",
  "friendsTitle": "Dostların",
  "friendsCount": "{{count}} nəfər",
  "friendsEmpty": "Hələ heç kimi dəvət etməmisən",
  "friendId": "ID: {{id}}",
  "friendDeposit": "Depozit: {{amount}}",
  "friendEarned": "Sizə: {{amount}}",
  "friendPending": "Gözləmədə: {{amount}}",
  "friendPendingUntil": "{{date}} tarixində reala keçəcək",
  "loginRequired": "Dəvət linkini görmək üçün daxil olun.",
  "navLabel": "Dost dəvəti"
}
